import React from 'react';
/**
 * Injects hidden product data in the Product Card and Product Card related components
 * for Product Card D&A tracking events
 *
 * NOTE: Card position is only needed inside of Product Grids.
 */
var ProductAnalyticsData = function (_a) {
    var cardPosition = _a.cardPosition, shopifyId = _a.shopifyId;
    return (React.createElement("div", { hidden: true },
        React.createElement("div", { "data-label": "productCard_position" }, cardPosition),
        React.createElement("div", { "data-label": "productCard_shopifyProductId" }, shopifyId)));
};
export default ProductAnalyticsData;
